import { render, staticRenderFns } from "./registry.vue?vue&type=template&id=d3f4fc36&scoped=true"
import script from "./registry.vue?vue&type=script&lang=js"
export * from "./registry.vue?vue&type=script&lang=js"
import style0 from "./registry.vue?vue&type=style&index=0&id=d3f4fc36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f4fc36",
  null
  
)

export default component.exports